export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-little-5.02ee9495.svg";